import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  DEPARTMENT_GET_REQUEST,
  DEPARTMENT_GET_SUCCESS,
  DEPARTMENT_GET_FAILURE,
  DEPARTMENT_GET_RESET,
  DEPARTMENT_LIST_REQUEST,
  DEPARTMENT_LIST_SUCCESS,
  DEPARTMENT_LIST_FAILURE,
  DEPARTMENT_LIST_RESET,
  DEPARTMENT_CREATE_REQUEST,
  DEPARTMENT_CREATE_SUCCESS,
  DEPARTMENT_CREATE_FAILURE,
  DEPARTMENT_CREATE_RESET,
  DEPARTMENT_EDIT_REQUEST,
  DEPARTMENT_EDIT_SUCCESS,
  DEPARTMENT_EDIT_FAILURE,
  DEPARTMENT_EDIT_RESET,
  DEPARTMENT_DEACTIVATE_REQUEST,
  DEPARTMENT_DEACTIVATE_SUCCESS,
  DEPARTMENT_DEACTIVATE_FAILURE,
  DEPARTMENT_DEACTIVATE_RESET,
  DEPARTMENT_EXPORT_REQUEST,
  DEPARTMENT_EXPORT_SUCCESS,
  DEPARTMENT_EXPORT_FAILURE,
  DEPARTMENT_EXPORT_RESET,
} from './../../constants'

export function createDepartment(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/departments`,
      method: 'POST',
      types: [
        DEPARTMENT_CREATE_REQUEST,
        DEPARTMENT_CREATE_SUCCESS,
        DEPARTMENT_CREATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function getDepartment(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/departments`,
      method: 'GET',
      types: [
        DEPARTMENT_LIST_REQUEST,
        DEPARTMENT_LIST_SUCCESS,
        DEPARTMENT_LIST_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function getDepartmentByID(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/departments/${id}`,
      method: 'GET',
      types: [
        DEPARTMENT_GET_REQUEST,
        DEPARTMENT_GET_SUCCESS,
        DEPARTMENT_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function editDepartment(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/departments/${id}`,
      method: 'PUT',
      types: [
        DEPARTMENT_EDIT_REQUEST,
        DEPARTMENT_EDIT_SUCCESS,
        DEPARTMENT_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function deactivateDepartment(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/departments/${id}/delete`,
      method: 'PUT',
      types: [
        DEPARTMENT_DEACTIVATE_REQUEST,
        DEPARTMENT_DEACTIVATE_SUCCESS,
        DEPARTMENT_DEACTIVATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function exportDepartment(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/departments/exports`,
      method: 'GET',
      types: [
        DEPARTMENT_EXPORT_REQUEST,
        DEPARTMENT_EXPORT_SUCCESS,
        DEPARTMENT_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function resetListDepartment() {
  return {
    type: DEPARTMENT_LIST_RESET,
  }
}
export function resetCreateDepartment() {
  return {
    type: DEPARTMENT_CREATE_RESET,
  }
}
export function resetEditDepartment() {
  return {
    type: DEPARTMENT_EDIT_RESET,
  }
}
export function resetGetDepartment() {
  return {
    type: DEPARTMENT_GET_RESET,
  }
}
export function resetDeactivateDepartment() {
  return {
    type: DEPARTMENT_DEACTIVATE_RESET,
  }
}
export function resetExportDepartment() {
  return {
    type: DEPARTMENT_EXPORT_RESET,
  }
}



// WEBPACK FOOTER //
// ./src/actions/department/department-action.js